// PLUGINS IMPORTS //
import React, { ReactNode } from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  children: ReactNode
  title: string
}

const BodySection: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <Title>{props.title}</Title>
      {props.children}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  text-align: start;
  margin-bottom: 40px;
  line-height: 26px;
`

const Title = styled.div`
  font-weight: bold;
  font-size: 25px;
  margin-bottom: 10px;
`

export default React.memo(BodySection, memoComparison)
